import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MessageThreadComponent } from '../message-thread/message-thread.component';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_CONFIG } from '../../app.config';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import { IAppConfig } from '../../app.config.shared';

@Component({
  selector: 'app-message-thread-new',
  templateUrl: './message-thread-new.component.html',
  styleUrls: ['./message-thread-new.component.scss']
})
export class MessageThreadNewComponent extends MessageThreadComponent {
  @Input() messageObject: any;
  @Input() pageUrl: string;
  @Output() closeThread = new EventEmitter();
  @Output() reply = new EventEmitter();
  @Output() onDropdownSelect = new EventEmitter();

  constructor(
    notificationService: NotificationService,
    @Inject(APP_CONFIG) _config: IAppConfig,
    _commonAuthService: CommonAuthenticationService,
    _commonRequestResponseService: CommonRequestResponseService,
    draggableModalService: DraggableModalService,
    _commonService: CommonService,
    _router: Router,
    _routes: ActivatedRoute
  ) {
    super(notificationService, _config, _commonAuthService, _commonRequestResponseService, draggableModalService, _commonService, _router, _routes);
  }

  redirectToProfilePage(message: any) {
    if (!message.mine) {
      this.gotoStudent(message.userRole, message.profileID, message.partnerID, message.createdByUserID);
    }
  }

  isCoach(role: string) {
    return role.toLowerCase().indexOf('coach') > -1;
  }

}
